import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-photo-video-modal',
  templateUrl: './upload-photo-video-modal.component.html',
  styleUrls: ['./upload-photo-video-modal.component.scss']
})
export class UploadPhotoVideoModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
